import { AlertTriangle } from 'lucide-react';

/**
 * TRN-1 (K69) — technician-facing review-required signal for AI-drafted
 * training summaries.
 *
 * `generate-training-summary` writes AI paraphrases with
 * `summary_source = 'ai_draft'`. Those summaries surface to technicians (the
 * artifact detail modal + passport recommendation card) with no signal that
 * they are unreviewed machine output — so a technician can read an inaccurate
 * AI paraphrase as authoritative. This renders a clear "AI draft · unreviewed"
 * warning whenever the summary is AI-drafted; it renders nothing for `manual`
 * or unset sources.
 *
 * This is the client-side mitigation only (TRN-1 → PARTIAL). A durable
 * review/approval workflow (a reviewed/approved state + admin publish gate)
 * remains for full closure.
 */
export function AiDraftSummaryNotice({
  summarySource,
  className,
}: {
  summarySource?: string | null;
  className?: string;
}) {
  if (summarySource !== 'ai_draft') return null;
  return (
    <p
      role="note"
      data-testid="ai-draft-summary-notice"
      className={`mt-1 flex items-center gap-1 text-xs text-amber-600 dark:text-amber-500 ${className ?? ''}`}
    >
      <AlertTriangle className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span>AI draft · unreviewed — verify before relying on this summary.</span>
    </p>
  );
}
